// @flow
import * as React from 'react';
import CreatableDropdown from './CreatableDropdown';
import SelectDropdown from './SelectDropdown';
import { connect } from 'react-redux';
import { isAdminOfAtLeastOneCustomer } from '../helpers';
import { bindActionCreators } from 'redux';
import { getCustomers } from '../actions/customers/basicCreators';
import type { Customer, Dispatch, Authentication } from '../types';

type Props = {
  organisations: Object[],
  currentOrganisation: Object,
  updateCurrentOrganisation: (oid: number, s: boolean) => void,
  getOrganisations: (oid?: number, p?: boolean, a?: boolean) => void,
  getCustomers: () => void,
  customers: Array<Customer>,
  router: any,
  authentication: Authentication,
  onClickNew?: () => void
};

class OrganisationSelect extends React.Component<Props> {
  componentDidMount() {
    this.props.getOrganisations();
    this.props.getCustomers();
  }

  handleOrgChange = (organisationId: number) => {
    this.props.updateCurrentOrganisation(organisationId, true);
  };

  render() {
    const {
      organisations,
      currentOrganisation,
      router,
      customers,
      onClickNew
    } = this.props;
    return isAdminOfAtLeastOneCustomer(customers) ||
      this.props.authentication.user.isInternalAdminUser ? (
      <CreatableDropdown
        onChange={this.handleOrgChange}
        value={currentOrganisation.id}
        options={organisations}
        aria-label="Customer Select Box"
        createNewUrl="/customer/create"
        label="Create Customer"
        router={router}
        onClick={onClickNew}
      />
    ) : (
      <SelectDropdown
        onChange={this.handleOrgChange}
        value={currentOrganisation.id}
        options={organisations}
        aria-label="Customer Select Box"
      />
    );
  }
}
function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    customers: state.customers
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getCustomers
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganisationSelect);



// WEBPACK FOOTER //
// ./src/components/OrganisationSelect.js